import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { getCurrentCulture } from "@utils";
import { Link } from "react-router-dom";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

export default observer(function LinkActiveEventsHOC(props: {
	className: string;
	children: React.ReactNode;
	offer: BetOffer;
}) {
	const myBetsStore = useContext(MyBetsStoreContext);

	if (
		myBetsStore?.activeEventsStore.eventsMap.has(props.offer.eventId) &&
		!window.location.pathname.includes(props.offer.eventId)
	) {
		const page = props.offer.isLive
			? `${DefaultPath.LIVE}/event`
			: `${DefaultPath.PREMATCH}/event`;
		const url = `/${getCurrentCulture()}/${page}/${props.offer.eventId}`;

		return (
			<Link className={props.className} to={url}>
				{props.children}
			</Link>
		);
	}

	return <>{props.children}</>;
});
